<template>
	<div class="element-container">
		<h2>Create Group</h2>
		
		<div class="group-create-container card">
			<form @submit.prevent="saveGroup">
				<div class="field">
					<label for="groupName">
						<Icon name="tv-groups" size="sm"/>
						Group Name
					</label>
					<input id="groupName" v-model.trim="groupName" type="text" required placeholder="Front Bar TVs"/>
				</div>
				
				<div class="field">
					<label for="defaultApp">
						<Icon name="app" size="sm"/>
						Default Launch App
					</label>
					<select id="defaultApp" v-model="defaultApp">
						<option v-for="app in availableApps" :key="app.value" :value="app.value">{{ app.label }}</option>
					</select>
				</div>
				
				<div class="field">
					<label>Displays (not in any group)</label>
					<div v-if="ungroupedTvs.length" class="device-list">
						<label v-for="tv in ungroupedTvs" :key="tv.id" class="device-row">
							<input type="checkbox" :value="tv.id" v-model="selectedTvIds"/>
							<span class="device-name">{{ tv.name }}</span>
							<span class="device-meta">{{ tv.code ? `ID • ${tv.code}` : 'Unidentified' }}</span>
						</label>
					</div>
					<p v-else class="empty-devices">No ungrouped displays available.</p>
				</div>
				
				<div class="buttons">
					<button class="btn-back" @click="cancel">
						<Icon name="arrow-left" size="sm"/>
						Back
					</button>
					<button type="submit" class="primary">
						Create Group
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue'
import {useRouter} from 'vue-router'
import {useMainStore} from '../store/main'
import Icon from "./Icon.vue";

const store = useMainStore()
const router = useRouter()

const groupName = ref('')
const defaultApp = ref('none')
const selectedTvIds = ref([])

const availableApps = computed(() => {
	return [
		{key: 'none', label: 'No Default App'},
		...store.apps
	]
})

const ungroupedTvs = computed(() => store.pairedTVs.filter(t => !t.group))

function cancel() {
	router.push('/home')
}

function saveGroup() {
	const name = groupName.value.trim()
	if (!name) return
	
	const groupId = Date.now()
	const group = {
		id: groupId,
		name,
		defaultApp: defaultApp.value,
		members: [...selectedTvIds.value]
	}
	
	store.addGroup(group)
	if (group.members.length) {
		store.assignTvsToGroup(groupId, group.members)
	}
	
	router.push('/home')
}

onMounted(async () => {
	if (store.apps.length === 0) {
		await store.loadApps()
	}
})
</script>

<style scoped>
h2 {
	margin: 0 0 var(--spacing-lg) 0;
}

.field {
	margin-bottom: var(--spacing-lg);
}

label {
	display: block;
	margin-bottom: var(--spacing-xs);
}

input, select {
	width: 100%;
	padding: var(--spacing-sm);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-sm);
	background: var(--color-surface, #141414);
	color: var(--color-text, #fff);
}

.device-list {
	display: grid;
	gap: 8px;
}

.device-row {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px;
	border: 1px solid var(--color-border, #2a2a2a);
	border-radius: 8px;
}

.device-row input {
	width: auto;
}

.device-name {
	font-weight: 600;
}

.device-meta {
	margin-left: auto;
	opacity: 0.7;
	font-size: 12px;
}

.empty-devices {
	opacity: 0.8;
	font-size: 14px;
}

.actions {
	display: flex;
	justify-content: space-between;
	gap: var(--spacing-sm);
}

.buttons {
	display: flex;
	width: 100%;
	justify-content: center;
	gap: 1rem;
}

.primary {
	background: var(--color-primary, #2d7ff9);
	width: 60%;
	color: #fff;
	border: none;
	padding: 10px 16px;
	border-radius: 10px;
	font-weight: 700;
}

.ghost {
	background: transparent;
	color: var(--color-text);
	border: 1px solid var(--color-border, #2a2a2a);
	padding: 10px 16px;
	border-radius: 10px;
}
</style>